import { render } from "./App.vue?vue&type=template&id=64385d0b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=64385d0b&lang=css"

import exportComponent from "D:\\a\\1\\s\\JAN-2211154-DEV\\landing-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__